module.exports = __webpack_public_path__ + "static/media/logo.833b97f8.png";